/**
 * "Ada Lovelace" -> "AL", "ada@x.com" -> "AD". Never more than two glyphs, and
 * never empty: an avatar with nothing in it reads as a failed image.
 *
 * Lifted out of SidebarAccount when the profile screen needed the same fallback
 * — `features/` cannot import from `app/`, and two copies of this would drift
 * the moment one of them learned about middle names.
 */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1] ?? '') : '';
  const letters = `${first.charAt(0)}${last.charAt(0)}` || first.slice(0, 2);
  return letters.toUpperCase() || '?';
}
